/* eslint-disable react/jsx-no-target-blank */
import {useIntl} from 'react-intl'
import {AsideMenuItemWithSub} from './AsideMenuItemWithSub'
import {AsideMenuItem} from './AsideMenuItem'
import {useAuth} from '../../../../app/modules/auth'
import { getUserGroupByUserId } from '../../../../Adaptor/TUBSIS'
import { useEffect, useState } from 'react'
import { GetUserGroupByUserIdOutput } from '../../../../Adaptor/TUBSIS/controllers/UserGroups/models/getUserGroupModels'

export function AsideMenuMain() {
  const intl = useIntl()

  const {currentUser, logout} = useAuth()

  const [userGroups, setUserGroups] = useState<GetUserGroupByUserIdOutput[] | null>(null)

  useEffect(() => {
    if (currentUser && currentUser.id !== null && !userGroups) {
      getUserGroupByUserId(currentUser?.id)
        .then((response) => {
          //console.log("çalıştı", JSON.stringify(response.data))
          setUserGroups(response.data)
        })
        .catch((error) => {
          console.error("Error fetching user claims:", error);
        });
    }
  },[currentUser])

  return (
    <>
      {/* <AsideMenuItem
        to='/dashboard'
        icon='color-swatch'
        title={intl.formatMessage({id: 'MENU.DASHBOARD'})}
        fontIcon='bi-app-indicator'
      /> */}
      {/* <AsideMenuItem to='/builder' icon='switch' title='Layout Builder' fontIcon='bi-layers' />*/}
      
      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>
            {intl.formatMessage({id: 'MENU.APPLICANTMENU'})}
          </span>
        </div>
      </div>
      <AsideMenuItemWithSub
        to='/crafted/pages'
        title={intl.formatMessage({id: 'MENU.APPLICANTMENU'})}
        fontIcon='bi-archive'
        icon='abstract-16'
      >
        <AsideMenuItemWithSub
          to='/crafted/pages/profile'
          title={intl.formatMessage({id: 'MENU.MY_PROGRESS'})}
          hasBullet={true}
        >
          <AsideMenuItem
            to='/crafted/pages/profile/overview'
            title={intl.formatMessage({id: 'MENU.OVERVIEW'})}
            hasBullet={true}
          />
          <AsideMenuItem
            to='/crafted/pages/profile/contents'
            title={intl.formatMessage({id: 'MENU.CONTENTS'})}
            hasBullet={true}
          />
        </AsideMenuItemWithSub>
      </AsideMenuItemWithSub>
      
      {/* <AsideMenuItem to='/Icons' title='Icons' /> */}
      {currentUser?.leadershipCourses && currentUser?.leadershipCourses.length > 0 && (
        <AsideMenuItemWithSub
          to='/consultant'
          title={intl.formatMessage({id: 'MENU.CONSULTANT'})}
          fontIcon='bi-archive'
          icon='clipboard'
        >
          <AsideMenuItem
            to='/consultant/home'
            title={intl.formatMessage({id: 'MENU.OVERVIEW'})}
            hasBullet={true}
          />

          <AsideMenuItem
            to='/consultant/patients'
            title={intl.formatMessage({id: 'MENU.PATIENTS'})}
            hasBullet={true}
          />
        </AsideMenuItemWithSub>
      )}
      {/* admin, expert veya officer ise */}
      {userGroups && userGroups?.filter(ug=>ug.id === '3' || ug.id === '4' || ug.id === '5')?.length > 0 && (
        <AsideMenuItemWithSub
          to='/appointment'
          title={intl.formatMessage({id: 'MENU.APPOINTMENT'})}
          fontIcon='bi-archive'
          icon='clipboard'
        >
          <AsideMenuItem
            to='appointment/calendar'
            title={intl.formatMessage({id: 'MENU.APPOINTMENTCALENDAR'})}
            hasBullet={true}
          />
          <AsideMenuItem
            to='appointment/home'
            title={intl.formatMessage({id: 'MENU.APPOINTMENTS'})}
            hasBullet={true}
          />
          <AsideMenuItem
            to='appointment/restrictions'
            title={intl.formatMessage({id: 'MENU.RESTRICTEDAPPOINTMENTDATES'})}
            hasBullet={true}
          />
        </AsideMenuItemWithSub>

      )}
      {/* admin veya expert ise */}
      {userGroups && userGroups?.filter(ug=>ug.id === '3' || ug.id === '4')?.length > 0 && (
        <AsideMenuItemWithSub
          to='/patient'
          title={intl.formatMessage({id: 'MENU.PATIENT'})}
          fontIcon='bi-archive'
          icon='clipboard'
        >
          <AsideMenuItem
            to='patient/home'
            title={intl.formatMessage({id: 'MENU.PATIENTLIST'})}
            hasBullet={true}
          />
        </AsideMenuItemWithSub>
      )}
    </>
  )
}
